'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/react/react.js
// module id = 1
// module chunks = 8